/** @jsxImportSource @emotion/react */
import styled from "@emotion/styled";
import { FaCopy } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { toast } from "react-toastify";
import { ITagUsedIn } from "../../../../types/TagTypes";

const Container = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  z-index: 99991;
  height: fit-content;
  width: 300px;
  max-height: 300px;
  border-radius: 5px;
  background-color: #fff;
  margin-top: 21px;
  margin-left: -30px;
  box-shadow: 0px 3px 20px #00000026;

  :after {
    content: "";
    position: absolute;
    display: block;
    border-style: solid;
    border-color: #fff transparent;

    border-width: 9px 7px 0;
    top: -9px;
    left: 50px;
    transform: rotate(180deg);
    width: 0;
    z-index: 1;
  }

  :before {
    content: "";
    position: absolute;
    border-style: solid;
    border-color: #ededed transparent;
    display: block;

    border-width: 10px 8px 0;
    top: -10px;
    left: 49px;
    transform: rotate(180deg) translateY(0.5px);
    width: 0;
    z-index: 1;
  }
`;

const TooltipText = styled.span`
  font-size: 14px;
  letter-spacing: 0px;
  color: #fff;
  text-align: center;
`;
const CampaignsUsedTag = styled.div`
  width: fit-content;
  max-width: 100%;
  background-color: #f2f2f2;
  color: #2f2f2f;

  border-radius: 4px;
  max-height: 32px;
  padding: 6px 11px;
  font-size: 15px;
  margin: 8px;
  margin-left: 0px;

  &:first-child {
    margin-left: 0px;
  }
`;

const TextContainer = styled.div`
  text-overflow: ellipsis;
  max-width: 100%;
  overflow: hidden;
  white-space: nowrap;
`;

const PopoverHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 25px 0px 25px;

  > p {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
  }

  > div > svg {
    cursor: pointer;
  }
`;

const PopoverContent = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  padding: 0px 25px 0px 25px;
`;

const CopyContainer = styled.div`
  display: flex;
  align-items: center;
  color: #fb972e;
  cursor: pointer;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 7px;
  transition: opacity 0.3s;

  > svg {
    margin-right: 8px;
  }

  &:hover {
    opacity: 0.8;
  }
`;

const Divider = styled.div`
  margin: 14px 0px;
  border-bottom: 1px solid #e2e2e2;
  width: 100%;
`;

interface Props {
  tagList: { id: string; name: string; type: ITagUsedIn }[];
  type: ITagUsedIn;
  isOpen: boolean;
  handleClose: () => void;
}

const COPY = {
  "start-tag": "Campaigns it starts",
  "stop-tag": "Campaigns it stops",
  "node-tag": "Campaigns used in",
  form: "Forms used in",
};

export default function CampaignListPopover(props: Props) {
  const { tagList, isOpen, handleClose, type } = props;

  function handleCopyToClipboard() {
    navigator.clipboard.writeText(tagList.map((c) => c.name).join(", "));
    toast("Campaign list successfully copied to the clipboard!", {
      type: "success",
    });
  }

  if (!isOpen) return <></>;
  return (
    <Container>
      <PopoverHeader>
        <p>{COPY[type]}</p>
        <div onClick={handleClose}>
          <IoMdClose size={22} color="#868482" />
        </div>
      </PopoverHeader>
      <Divider />
      <PopoverContent>
        <CopyContainer onClick={handleCopyToClipboard}>
          <FaCopy />
          Copy list to clipboard
        </CopyContainer>
        {!!tagList.length &&
          tagList.map((campaign) => (
            <CampaignsUsedTag
              data-tip
              data-for={`${campaign.id}_tooltip`}
              id="tag-container"
            >
              <TextContainer>{campaign.name}</TextContainer>
            </CampaignsUsedTag>
          ))}
      </PopoverContent>
    </Container>
  );
}
